import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { RaiseTicketComponent } from './raise-ticket/raise-ticket.component';
import { ConfirmComponent } from '../../shared/components/confirm/confirm.component';
import { ViewTicketCommentsComponent } from './view-ticket-comments/view-ticket-comments.component';
import { AddTicketCommentsComponent } from './add-ticket-comments/add-ticket-comments.component';
import { MatDialogCloseEvent, PageKey, Role } from '../../const';
import { PageEvent } from '@angular/material/paginator';
import { TicketManagementService } from './ticket-management.service';
import { DtoTicketCommentDetail, DtoTicketDetails } from '../../models/ticket-details.model';
import { ToastrService } from 'ngx-toastr';
import { ViewTicketDescriptionComponent } from './view-ticket-description/view-ticket-description.component';
import { UploadedFilesComponent } from './uploaded-files/uploaded-files.component';
import { SearchService } from '../common/search.service';

export enum Tabs { MyTickets = "My Tickets", AccountTickets = "Account Tickets" }

@Component({
  selector: 'app-ticket-management',
  templateUrl: './ticket-management.component.html'
})
export class TicketManagementComponent {
  ticketDetails: any[] = [];
  userRole: string[] = [];
  roles = Role;
  roleName: string[] = [];
  userEmail: string = "";
  totalRecords: number = 0;
  isAssignedTicketsLoaded: boolean = false;
  sortColumn: string = "";
  sortDirection: string = "";

  searchTerm: string = "";
  pageKey = PageKey.TicketManagementCenter;
  pageSize: number = 10;
  pageNumber: number = 0;
  pageOffSet: number = 0;
  activeTab: string = Tabs.AccountTickets;
  tabs = Tabs;
  sortNameAsc: boolean = true;
  sortAssignedToAsc: boolean = true;
  loggedInUserId: number = 0;
  maxSize: number = 1 * 1024 * 1024; // 1 MB in bytes

  constructor(
    public dialog: MatDialog,
    private ticketManagementService: TicketManagementService,
    private toasterService: ToastrService,
    private readonly searchService: SearchService
  ) { }

  ngOnInit(): void {
    this.userRole = sessionStorage.getItem('user_role')?.split(',')!;
    this.userEmail = sessionStorage.getItem('user_email')!;
    this.searchTerm = this.searchService.getSearchTerm(this.pageKey);

    this.loggedInUserId = parseInt(sessionStorage.getItem('user_id')!);
    this.userRole?.forEach(element => {
      this.roleName.push(this.getRoleNameByValue(Role, element)!);
    });

    const fetchTickets = this.userRole?.includes(this.roles.SuperAdmin) ||
      this.userRole?.includes(this.roles.AccountAdmin)
      ? this.getAssignedTickets
      : this.getTicketsRaisedByUser;

    // Calling the respective method
    fetchTickets.call(this);
  }

  onFileSelected(event: any, ticket: any) {
    const file = event.target.files[0];

    if (file) {
      if (file.size <= this.maxSize) {
        ticket.selectedFile = file;
        ticket.selectedFileName = file.name;

        const formData = new FormData();
        formData.append('TicketId', ticket.ticketId);

        if (ticket.selectedFile) {
          formData.append('File', ticket.selectedFile, ticket.selectedFile.name);
        }

        this.ticketManagementService.uploadTicketDocument(formData).subscribe({
          next: (response) => {
            this.toasterService.success('Document uploaded successfully!', 'Success');
            this.fetchRelevantTickets();
          },
          error: (error) => {
            console.error('Error uploading ticket document', error);
            this.toasterService.error(error, 'Error')
          }
        });
      } else {
        this.toasterService.warning('File size must be less than 1 MB.');
        ticket.selectedFile = null;
        ticket.selectedFileName = 'Click to upload';
      }
    } else {
      ticket.selectedFile = null;
      ticket.selectedFileName = 'Click to upload';
    }
  }

  openRaiseTicketModal() {
    this.dialog.open(RaiseTicketComponent, {
      width: '1200px'
    }).afterClosed().subscribe((popupEvent: any) => {
      if (popupEvent?.event == MatDialogCloseEvent.SUCCESS) {
        this.activeTab = this.tabs.MyTickets;
        this.resetPage();
        this.getTicketsRaisedByUser();
      }
    });
  }


  removeSpaces(str: string): string {
    return str.replace(/\s+/g, '');
  }

  viewTicketCommentModal(ticketCommentDetails: DtoTicketCommentDetail[]) {
    this.dialog.open(ViewTicketCommentsComponent, {
      width: '900px',
      data: { comments: ticketCommentDetails }
    });
  }
  viewTicketDescriptionModal(description: string) {
    this.dialog.open(ViewTicketDescriptionComponent, {
      width: '600px',
      data: { Description: description }
    });
  }
  viewUploadedFilesModal(url: string) {
    this.dialog.open(UploadedFilesComponent, {
      width: '600px',
      data: { Url: url }
    });
  }
  addTicketCommentModal(ticketId: number) {
    if (this.isAssignedTicketsLoaded) {
      this.dialog.open(AddTicketCommentsComponent, {
        width: '900px',
        data: { ticketId: ticketId }
      }).afterClosed().subscribe((popupEvent: any) => {
        if (popupEvent?.event == MatDialogCloseEvent.SUCCESS) {
          this.getAssignedTickets();
        }
      });
    }
  }


  deleteRaiseTicketModal(ticketId: number) {
    this.dialog.open(ConfirmComponent, {
      width: '375px',
      data: {
        status: true,
        message: "Are you sure want to delete the ticket?"
      }
    }).afterClosed().subscribe((popupEvent: any) => {
      if (popupEvent?.event == MatDialogCloseEvent.SUCCESS) {
        this.ticketManagementService.deleteTicket(ticketId).subscribe({
          next: (response) => {
            if (response) {
              this.toasterService.success('Ticket deleted successfully!', 'Success');
              this.getTicketsRaisedByUser();
            }
          },
          error: (error) => {
            console.error('Error deleting tickets', error);
          }
        });
      }
    });
  }

  getRoleNameByValue<T extends { [index: string]: string }>(
    enumObj: T,
    value: string
  ): string | undefined {
    const keys = Object.keys(enumObj).filter((x) => enumObj[x] === value);
    return keys.length > 0 ? keys[0] : undefined;
  }

  ApplySearch() {
    
    this.pageNumber = 0
    this.pageOffSet = 0;
    this.searchService.setSearchTerm(this.pageKey, this.searchTerm);
    this.searchTerm = this.searchTerm ? this.searchTerm.trim() : "";
    this.resetPage();
    this.fetchRelevantTickets();

  }

  changeTab(tabName: string) {
    this.activeTab = tabName;
    this.ticketDetails = [];
    this.resetPage();
    this.sortColumn = "";
    this.sortDirection = "";
    const fetchTickets = tabName === this.tabs.AccountTickets ? this.getAssignedTickets : this.getTicketsRaisedByUser;

    // Invoke the method to fetch tickets
    fetchTickets.call(this);
  }

  changePage(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.pageNumber = event.pageIndex;
    this.pageOffSet = this.pageNumber * this.pageSize;
    this.fetchRelevantTickets();
  }

  getAssignedTickets() {
    this.isAssignedTicketsLoaded = true;
    this.ticketManagementService.getAssignedTickets(this.pageSize, this.pageOffSet, this.searchTerm, this.sortColumn, this.sortDirection).subscribe({
      next: (response: DtoTicketDetails[] | any) => {
        this.ticketDetails = response;
        this.totalRecords = response.length ? parseInt(response[0].totalRecords) : 0;
      },
      error: (error) => {
        console.error('Error fetching tickets', error);
      }
    });
  }


  getTicketsRaisedByUser() {
    this.isAssignedTicketsLoaded = false;
    this.ticketManagementService.getTicketsRaisedByUser(this.pageSize, this.pageOffSet, this.searchTerm, this.sortColumn, this.sortDirection).subscribe({
      next: (response: DtoTicketDetails[] | any) => {
        this.ticketDetails = response;
        this.totalRecords = response.length ? parseInt(response[0].totalRecords) : 0;
      },
      error: (error) => {
        console.error('Error fetching tickets', error);
      }
    });
  }

  openAttachment(url: string): void {
    if (url) {
      window.open(url, '_blank');
    }
  }

  resetPage() {
    this.pageSize = 10;
    this.pageNumber = 0;
    this.pageOffSet = 0;
  }

  getSortedTicketData(sortColumn: string, sortDirection: string) {
    this.sortColumn = sortColumn;
    this.sortDirection = sortDirection;
    this.fetchRelevantTickets();
  }

  fetchRelevantTickets() {

    // Determine which API method to call based on user role and active tab
    const shouldFetchAssignedTickets =
      this.userRole?.includes(this.roles.SuperAdmin) ||
      (this.userRole?.includes(this.roles.AccountAdmin) && this.activeTab === this.tabs.AccountTickets);

    if (shouldFetchAssignedTickets) {
      this.getAssignedTickets();
    } else {
      this.getTicketsRaisedByUser();
    }
  }
}
